import { createDirectChatroomsApi } from "./direct-chatrooms";
import { Api } from '../types'
import { HttpClient } from '../httpClient'
import { createExpertApi } from './expert.personal'
import { createCategoriesApi } from './categories.public'
import { createUploadsApi } from './uploads'
import { createMediaApi } from './media'
import { createAdminMediaApi } from './media.admin'
import { createExpertPublicApi } from './expert.public'
import { createPredictiveSearchApi } from './predictive-search'
import { createAdminReviewsV2Api } from './reviews-v2.admin'
import { createAdminReviewsImportApi } from './reviews-import.admin'
import { createClientReviewsV2Api } from './reviews-v2.client'
import { createExpertReviewsV2Api } from './reviews-v2.expert'
import { createExpertReviewShareBackgroundsApi } from './review-share-backgrounds.expert'
import { createPublicReviewsV2Api } from './reviews-v2.public'
import { createAdminBadgesApi } from './badges.admin'
import { createExpertBadgesApi } from './badges.expert'
import { createAdminExpertApi } from './expert.admin'
import { createAdminExpertSubscriptionsApi } from './expert-subscriptions.admin'
import { createAdminExpertBillingApi } from './expert-billing.admin'
import { createExpertBillingApi } from './expert-billing.expert'
import { createPublicBadgesApi } from './badges.public'
import { createPublicPagesApi } from './pages.public'
import { createAdminPagesApi } from './pages.admin'
import { createPublicRedirectsApi } from './redirects.public'
import { createAdminRedirectsApi } from './redirects.admin'
import { createAdminLeadsV2Api } from './leads-v2.admin'
import { createClientLeadsV2Api } from './leads-v2.client'
import { createExpertLeadsV2Api } from './leads-v2.expert'
import { createAdminDraftLeadsApi } from './draft-leads.admin'
import { createPublicDraftLeadsApi } from './draft-leads.public'
import { createPublicAuthApi } from './auth.public'
import { createPublicInvitesApi } from './invites.public'
import { createClientStoresV2Api } from './stores-v2.client'
import { createClientProfileApi } from './profile.client'
import { createExpertProfileApi } from './profile.expert'
import { createExperimentalAdminExpertsExportApi } from './experts-export.experimental.admin'
import { createExpertAnalyticsApi } from './analytics.expert'
import { createAdminExpertManagerApi } from './experts-manager.admin'
import { createAdminServiceCategoriesApi } from './service-categories.admin'
import { createClientProjectsV2Api } from './projects-v2.client'
import { createExpertProjectsV2Api } from './projects-v2.expert'
import { createAdminProjectsV2Api } from './projects-v2.admin'
import { createGeoRegionsApi } from './geo-regions.public'
import { createCitiesApi } from './cities.public'
import { createPublicContactApi } from './public-contact'
import { createPublicBookingCallLeadsApi } from './booking-call-leads.public'
import { createExpertWalletApi } from './wallet.expert'
import { createAdminWalletApi } from './wallet.admin'
import { createAdminExpertLevelsApi } from './expert-levels.admin'
import { createAdminSatelliteContactSitesApi } from './satellite-contact-sites.admin'
import { createAdminSettingsApi } from './admin-settings.admin'
import { createPublicExpertClaimsApi } from './expert-claims.public'
import { createAdminExpertClaimsApi } from './expert-claims.admin'
import { createAdminBanListApi } from './ban-list.admin'
import { createAdminEmailsApi } from './emails.admin'
import { createAdminExpertAiSummariesApi } from './expert-ai-summaries.admin'

export function createApi(http: HttpClient, baseUrl: string): Api {
    const expertApi = createExpertApi(http, baseUrl);
    const expertReviewsV2Api = createExpertReviewsV2Api(http, baseUrl);
    const expertBadgesApi = createExpertBadgesApi(http, baseUrl);
    const adminReviewsV2Api = createAdminReviewsV2Api(http, baseUrl);
    const adminReviewsImportApi = createAdminReviewsImportApi(http, baseUrl);
    const adminMediaApi = createAdminMediaApi(http, baseUrl);
    const adminBadgesApi = createAdminBadgesApi(http, baseUrl);
    const adminExpertApi = createAdminExpertApi(http, baseUrl);
    const adminExpertSubscriptionsApi = createAdminExpertSubscriptionsApi(http, baseUrl);
    const adminExpertBillingApi = createAdminExpertBillingApi(http, baseUrl);
    const expertBillingApi = createExpertBillingApi(http, baseUrl);
    const adminPagesApi = createAdminPagesApi(http, baseUrl);
    const publicPagesApi = createPublicPagesApi(http, baseUrl);
    const adminRedirectsApi = createAdminRedirectsApi(http, baseUrl);
    const publicRedirectsApi = createPublicRedirectsApi(http, baseUrl);
    const adminLeadsV2Api = createAdminLeadsV2Api(http, baseUrl);
    const clientLeadsV2Api = createClientLeadsV2Api(http, baseUrl);
    const expertLeadsV2Api = createExpertLeadsV2Api(http, baseUrl);
    const adminDraftLeadsApi = createAdminDraftLeadsApi(http, baseUrl);
    const publicDraftLeadsApi = createPublicDraftLeadsApi(http, baseUrl);
    const adminExpertManagerApi = createAdminExpertManagerApi(http, baseUrl);
    const adminServiceCategoriesApi = createAdminServiceCategoriesApi(http, baseUrl);
    const experimentalAdminExpertsExportApi = createExperimentalAdminExpertsExportApi(http, baseUrl);
    const expertAnalyticsApi = createExpertAnalyticsApi(http, baseUrl);
    const clientProjectsV2Api = createClientProjectsV2Api(http, baseUrl);
    const expertProjectsV2Api = createExpertProjectsV2Api(http, baseUrl);
    const adminProjectsV2Api = createAdminProjectsV2Api(http, baseUrl);
    const expertProfileApi = createExpertProfileApi(http, baseUrl);
    const geoRegionsApi = createGeoRegionsApi(http, baseUrl);
    const citiesApi = createCitiesApi(http, baseUrl);
    const publicContactApi = createPublicContactApi(http, baseUrl);
    const publicBookingCallLeadsApi = createPublicBookingCallLeadsApi(http, baseUrl);
    const expertWalletApi = createExpertWalletApi(http, baseUrl);
    const adminWalletApi = createAdminWalletApi(http, baseUrl);
    const adminExpertLevelsApi = createAdminExpertLevelsApi(http, baseUrl);
    const adminSatelliteContactSitesApi = createAdminSatelliteContactSitesApi(http, baseUrl);
    const adminSettingsApi = createAdminSettingsApi(http, baseUrl);
    const publicExpertClaimsApi = createPublicExpertClaimsApi(http, baseUrl);
    const adminExpertClaimsApi = createAdminExpertClaimsApi(http, baseUrl);
    const adminBanListApi = createAdminBanListApi(http, baseUrl);
    const adminEmailsApi = createAdminEmailsApi(http, baseUrl);
    const adminExpertAiSummariesApi = createAdminExpertAiSummariesApi(http, baseUrl);

    return {
        directChatrooms: createDirectChatroomsApi(http, baseUrl),
        expert: {
            ...expertApi,
            profile: expertProfileApi,
            reviewsV2: expertReviewsV2Api,
            reviewShareBackgrounds: createExpertReviewShareBackgroundsApi(http, baseUrl),
            badges: expertBadgesApi,
            leadsV2: expertLeadsV2Api,
            analytics: expertAnalyticsApi,
            projectsV2: expertProjectsV2Api,
            wallet: expertWalletApi,
            billing: expertBillingApi,
        },
        categories: createCategoriesApi(http, baseUrl),
        geoRegions: geoRegionsApi,
        cities: citiesApi,
        uploads: createUploadsApi(http, baseUrl),
        media: createMediaApi(http, baseUrl),
        admin: {
            expert: adminExpertApi,
            reviewsV2: adminReviewsV2Api,
            reviewsImport: adminReviewsImportApi,
            media: adminMediaApi,
            badges: adminBadgesApi,
            pages: adminPagesApi,
            expertSubscriptions: adminExpertSubscriptionsApi,
            expertBilling: adminExpertBillingApi,
            redirects: adminRedirectsApi,
            leadsV2: adminLeadsV2Api,
            projectsV2: adminProjectsV2Api,
            draftLeads: adminDraftLeadsApi,
            expertManager: adminExpertManagerApi,
            serviceCategories: adminServiceCategoriesApi,
            wallet: adminWalletApi,
            expertLevels: adminExpertLevelsApi,
            satelliteContactSites: adminSatelliteContactSitesApi,
            settings: adminSettingsApi,
            expertClaims: adminExpertClaimsApi,
            banList: adminBanListApi,
            emails: adminEmailsApi,
            expertAiSummaries: adminExpertAiSummariesApi,
        },
        experimental: {
            admin: {
                expertsExport: experimentalAdminExpertsExportApi,
            },
        },
        client: {
            reviewsV2: createClientReviewsV2Api(http, baseUrl),
            leadsV2: clientLeadsV2Api,
            storesV2: createClientStoresV2Api(http, baseUrl),
            profile: createClientProfileApi(http, baseUrl),
            projectsV2: clientProjectsV2Api,
        },
        public: {
            expert: createExpertPublicApi(http, baseUrl),
            categories: createCategoriesApi(http, baseUrl),
            predictiveSearch: createPredictiveSearchApi(http, baseUrl),
            reviewsV2: createPublicReviewsV2Api(http, baseUrl),
            badges: createPublicBadgesApi(http, baseUrl),
            pages: publicPagesApi,
            redirects: publicRedirectsApi,
            auth: createPublicAuthApi(http, baseUrl),
            invites: createPublicInvitesApi(http, baseUrl),
            draftLeads: publicDraftLeadsApi,
            contact: publicContactApi,
            bookingCallLeads: publicBookingCallLeadsApi,
            expertClaims: publicExpertClaimsApi,
        },
    } 
}
